<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InpuForecastIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
